import gsap from "gsap";
import SplitText from "gsap/SplitText";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import initShareQuote from "./shareQuote";
import initFloatingVideo from "./floatingVideo";
import initFooterWaitlist from "./footerWaitlist";
import initContinueReading from "./continueReading";

// GSAP plugins are registered in index.js

export default function initPage() {
  const h1 = document.querySelector(".page__intro h1");
  const h2 = document.querySelector(".page__next h2");

  (document.fonts?.ready ?? Promise.resolve()).then(() => {

    // --- H1 ---
    if (h1) {
      const splitH1 = new SplitText(h1, { type: "words" });
      const h1Words = splitH1.words;

      gsap.set(h1, { opacity: 1 });
      gsap.set(h1Words, { opacity: 0, scale: 0.96, yPercent: 8, willChange: "transform,opacity" });

      gsap.timeline({ defaults: { ease: "power2.out" } })
        .to(h1Words, {
          opacity: 1,
          scale: 1,
          yPercent: 0,
          duration: 0.55,
          stagger: { each: 0.14, from: "start" },
          clearProps: "willChange,transform",
        });
    }

    // --- H2 on enter viewport ---
    if (h2) {
      const splitH2 = new SplitText(h2, { type: "words" });
      const h2Words = splitH2.words;

      gsap.set(h2, { opacity: 1 });
      gsap.set(h2Words, { opacity: 0, scale: 0.96, yPercent: 8, willChange: "transform,opacity" });

      const h2Tl = gsap.timeline({ paused: true, defaults: { ease: "power2.out" } })
        .to(h2Words, {
          opacity: 1,
          scale: 1,
          yPercent: 0,
          duration: 0.55,
          stagger: { each: 0.14, from: "start" },
          clearProps: "willChange,transform",
        });

      ScrollTrigger.create({
        trigger: ".page__next",
        start: "top center+=100",
        once: true,
        onEnter: () => h2Tl.play(),
      });
    }

    // --- Floating Video intro ---
    const floatingVideoEl = document.querySelector('#floating-video, .floatingVideo, .floating-video');
    if (floatingVideoEl) {
      gsap.to(floatingVideoEl, {
        scale: 1,
        duration: 1,
        delay: 0.2,
        ease: 'power3.inOut'
      });
    }


    // Init selection share after animations are set
    try { initShareQuote(); } catch (e) { /* no-op */ }
    try { initFloatingVideo(); } catch (e) { /* no-op */ }
    try { initFooterWaitlist(); } catch (e) { /* no-op */ }
    try { initContinueReading(); } catch (e) { /* no-op */ }
  });
}
